<template>
  <v-form ref="form" >

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>

      <v-col cols="12" v-if="storageAdjustment.isStockEntryType">
        <v-switch
          v-model="entry.isNewLot"
          @change="isNewLotChanged"
          inset 
          :label="entry.isNewLot ? 'É novo lote' : 'Não é novo lote'"
          :readonly="!storageAdjustment.isStockEntryType"
          :disabled="readOnly || isEdit"
        >
        </v-switch>
      </v-col>

      <v-col cols="12" v-if="entry.isNewLot && storageAdjustment.isStockEntryType">
        <v-text-field
          v-model="entry.lotNumber"
          v-bind="getObject('lotNumber')"
          label="Número"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" v-if="entry.isNewLot && storageAdjustment.isStockEntryType">
        <DateField
          :inputData.sync="entry.manufacturingDate"          
          v-bind="getObject('manufacturingDate')"
          label="Data de Fabricação"
          :hasTodayButton="true"
          :hasTodayDate="false"
          :disabled="readOnly"
          autocomplete="off"
        />
      </v-col>  

      <v-col cols="12" sm="6" v-if="entry.isNewLot && storageAdjustment.isStockEntryType">
        <DateField
          :inputData.sync="entry.dueDate"
          v-bind="getObject('dueDate')"
          label="Data de Validade"
          :hasTodayButton="true"
          :hasTodayDate="false"
          :disabled="readOnly"
          autocomplete="off"
        />
      </v-col>

      <v-col cols="12" sm="12" md="12" v-if="!entry.isNewLot || !storageAdjustment.isStockEntryType">
        <v-autocomplete
          v-model="entry.manufacturingLotId"
          v-bind="getObject('manufacturingLotId')"
          label="Lote"
          :items="this.lotItemsList"
          @input="changeSelectedItem"          
          item-value="id"
          item-text="name"          
          :disabled="readOnly"
          autocomplete="off"
        >
        <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title class="text-subtitle-1">{{data.item.name}}</v-list-item-title>
              <v-list-item-subtitle>
                Qtd. disponível: {{data.item.availableQuantity}} {{data.item.unitName}} - Qtd. de emb.: {{data.item.packagingQuantity}} {{data.item.packagingName}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-if="renderComponent"
          :inputData.sync="entry.packagingQuantity"
          mask-type="currency_10d"
          label="Quantidade de Embalagens"      
          @update:inputData="changePackagingQuantity"
          autocomplete="off"
          :disabled="readOnly"
          :suffix="packaging ? packaging.text : ''"
          :key="packagingQuantityKey + 'packagingQuantity'"
        />
        <!--   -->
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('quantity')"          
          :inputData.sync="entry.quantity"
          mask-type="currency_10d"
          label="Quantidade Unitária"          
          @update:inputData="changeQuantity"
          :hint="quantityHint"
          persistent-hint
          :disabled="readOnly"
          autocomplete="off"
          :suffix="itemSelected ? itemSelected.unitName : ''"
          :key="quantityKey + 'quantity'"
        />
        <!-- -->
      </v-col>
     
    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import gql from 'graphql-tag'
import BaseUtil from "@shared_components/base_util.vue"
import DateField from "@shared_components/date_field.vue";

export default {
  data() {
    return {
      entryAttributes: {},      
      lotItemsList: [],
      renderComponent: true,
      itemsSearch: "",
      unitPriceKey: 0,
      totalPriceKey: 0,
      packagingQuantity: 0,
      packagingQuantityKey: 0,
      quantityKey: 0,
      packagingPriceKey: 0,
      pageLoading: false,
      itemSelected: {},
      availableQuantity: 0,
    };
  },
  props: {
    entry: Object,
    originalEntry: Object,
    movementItem: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
    packaging: Object,
    itemLots: {
      type: Array,
      default: () => new Array(),
    },
    storageAdjustment: Object,
    isNewItemInStorage: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
    DateField: DateField,
  },
  created() {    
    // console.log("form created", this.entry);
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    // console.log("item purchase", this.entry.item)        
    if (this.entry.manufacturingLotId) {
      // this.purchaseItemsList = [this.entry.item];
      // this.selectItem(false);
      this.changeSelectedItem();
      this.changePackagingQuantity();
      this.changeQuantity();
    }
    
    this.loadItemLots();    
  },
  mounted() {   
  },
  computed: {
    quantityHint: function() {
      var availableQuantity =  parseFloat(this.itemSelected?.availableQuantity);
      if(this.isEdit && this.originalEntry?.id){
        availableQuantity += this.originalEntry.quantity;
      }
      // console.log("qtd = ", availableQuantity);
      return (this.entry.manufacturingLotId && this.itemSelected) ? "Quantidade disponível: " + this.numberToDecimal(availableQuantity) + " " + this.itemSelected?.unitName : "";
    },
  },
  watch: {
    itemsSearch: function(newSearch, oldSearch) {
      // console.log("newSearch", newSearch, "oldSearch", oldSearch)
      // if (this.itemsSearch && this.itemsSearch.length > 0) {
      //   if (!this.entry.item || this.entry.item.name != this.itemsSearch) {
      //     this.getPurchaseItems();
      //   }
      // }
    }
  },
  methods: {    
    loadItemLots: function(){
      for(var i=0;i<this.itemLots.length; i++){
        this.lotItemsList.push(this.itemLots[i]);
      }      
      // console.log("lotList", this.lotItemsList);
      if(this.lotItemsList.length==1 && !this.entry.isNewLot){
        this.entry.manufacturingLotId = this.lotItemsList[0].id;
      }
      // if(!this.isNewItemInStorage){
        this.changeSelectedItem();
      // }
    },
    availableLotQuantity: function(){
      if(this.entry.manufacturingLotId){
        this.$apollo
            .query({
              query: AVAILABLE_LOT_QUANTITY_FOR_ITEM_QUERY,
              fetchPolicy: "no-cache",
              variables: {
                itemId: this.movementItem.itemId,
                packagingId: this.movementItem.packagingId,
                storageId: this.storageAdjustment.storageId,
                movementItemLotId: this.entry.id,
                itemLotId: this.entry.manufacturingLotId || null,
              }
            })
            .then(response => {
              // console.log("response dos storages", response)                        
              // this.entryAttributes.quantity.rules = []
              if(!this.itemSelected){
                this.itemSelected = {};
              }
              this.itemSelected.availableQuantity = response.data.accountContext.availableLotQuantity;
              this.itemSelected.unitName = this.packaging.unitName;
              // console.log("response", response.data.accountContext.availableLotQuantity);
              if (!this.storageAdjustment.isStockEntryType){
                var availableQuantity =  parseFloat(this.itemSelected?.availableQuantity);
                if(this.isEdit){
                  availableQuantity += this.originalEntry.quantity;
                }
                this.entryAttributes.quantity.rules.push(this.maxValueRule(availableQuantity));
              }
              // console.log("fez busca !!!", this.itemLots);
              this.changePackagingQuantity();
              // console.log("item selected", this.itemSelected);            
            })
            .catch(response => console.log(response))
            .finally(() => (this.availableQuantityLoading = false)); 
      }     
    },
    changeSelectedItem: function(){
      this.itemSelected = this.lotItemsList.find(obj => obj.id == this.entry.manufacturingLotId);      
      // console.log("item", this.itemSelected);
      // console.log("storageAdjustment", this.storageAdjustment);
      if(this.itemSelected && !this.storageAdjustment.isStockEntryType){
        this.entryAttributes.quantity.rules = []
        var availableQuantity =  parseFloat(this.itemSelected?.availableQuantity);
        if(this.isEdit && this.originalEntry?.id){
          availableQuantity += this.originalEntry.quantity;
        }
        this.entryAttributes.quantity.rules.push(this.maxValueRule(availableQuantity));
      }
      if(!this.isNewItemInStorage){
        this.setItemLot(this.itemSelected);
      }
      this.changePackagingQuantity();
      // this.availableLotQuantity();
    },    
    changeQuantity: function() {
      this.entry.packagingQuantity = _.round(this.entry.quantity / this.packaging.size, 10);      
      this.packagingQuantityKey++;
      this.updateQuantity();
      // if(this.itemSelected){
      //   this.changeSelectedItem();
      // }
    },
    updateQuantity: function() {
      if (this.entry.unitPrice > 0) {
        this.calculatePackagingPrice();
        this.calculateTotalPrice();
      } else if (this.entry.price > 0) {
        this.calculateUnitPrice();
        this.calculatePackagingPrice();
      } else {
        this.entry.price = 0;
        this.totalPriceKey++;
        this.entry.unitPrice = 0;
        this.unitPriceKey++;
        this.entry.packagingPrice = 0;
        this.packagingPriceKey++;
      }
    },
    changePackagingQuantity: function() {
      this.entry.quantity = _.round(this.entry.packagingQuantity * this.packaging.size, 10);
      this.quantityKey++;
      this.updateQuantity();
    },
    changeUnitPrice: function() {
      if (this.entry.quantity > 0) {
        this.calculatePackagingPrice();
        this.calculateTotalPrice();
      }
    },
    changePackagingPrice: function() {
      if (this.entry.quantity > 0) {
        this.calculateUnitPrice(false);
        this.calculateTotalPrice();
      }
    },
    changeTotalPrice: function() {
      if (this.entry.quantity > 0) {
        this.calculateUnitPrice();
        this.calculatePackagingPrice();
      }
    },
    calculateTotalPrice: function() {
      this.entry.price = _.round((this.entry.unitPrice ? this.entry.unitPrice : 0) * (this.entry.quantity ? this.entry.quantity : 0), 2);
      this.totalPriceKey++;
    },
    calculateUnitPrice: function(byTotalPrice=true) {
      if (byTotalPrice) {
        this.entry.unitPrice = _.round((this.entry.price ? this.entry.price : 0) / (this.entry.quantity ? this.entry.quantity : 0), 10);
      } else { //calcula pelo preco unitario com base no preco da embalagem
        this.entry.unitPrice = _.round((this.entry.packagingPrice ? this.entry.packagingPrice : 0) / (this.packaging.size ? this.packaging.size : 0), 10);
      }
      this.unitPriceKey++;
    },
    calculatePackagingPrice: function() {
      this.entry.packagingPrice = _.round((this.entry.unitPrice ? this.entry.unitPrice : 0) * (this.packaging.size ? this.packaging.size : 0), 10);
      this.packagingPriceKey++;
    },
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },    
    clearFields: function() {
      this.forceRerender(this);
    },
    packagingCreated: function(packaging) {
      // this.selectItem(true, packaging);
    },
    storageCreated: function(storage) {
      this.extraData.accountContext.allStorages.unshift(storage);
      this.entry.storageId = storage.id;
      this.entry.storage = storage;
    },
    setItemLot: function(itemLot){      
      if(itemLot){
        this.entry.name = itemLot.name;
        this.entry.lotNumber = itemLot.lotNumber;
        this.entry.manufacturingDate = itemLot.manufacturingDate;
        this.entry.dueDate = itemLot.dueDate;
        this.entry.availableQuantity = itemLot.availableQuantity;
        this.entry.unitName = itemLot.unitName;
        this.entry.quantity = itemLot.quantity;                
      }
    },
    selectItemLot: function(item){
      // console.log("item", item);
      for (let i in this.lotItemsList){
        // console.log("i", i);
        if(this.lotItemsList[i].id == item){
          this.setItemLot(this.lotItemsList[i]);
        }
      }
      // console.log("entry", this.entry);
    },
    itemCreated: function(item) {
      // console.log("item created", item);
      this.lotItemsList.unshift(item);
      console.log(item);
      this.entry.manufacturingLotId = item.id;      
      item.quantity = this.quantity;
      item.packagingQuantity = this.packagingQuantity;
      this.setItemLot(item);
      // console.log("item", item);
      // this.selectItem(true);
    },
    isNewLotChanged: function(){

    }
  }
};

const ITEMS_FOR_PURCHASE_QUERY = gql `
  query ($query: String!) {
    accountGlobalSharedContext {
      allAvailableItemsForPurchase(query: $query) {
        id
        name
        unit {
          name
        }
        brand {
          name
        }
        typeText
      }
    }
  }
`;

const PACKAGINGS_FOR_ITEM_QUERY = gql `
  query ($itemId: ID!) {
    accountGlobalSharedContext {
      allPackagingsOfItem(itemId: $itemId) {
        id
        name
        size
        text
      }
    }
  }
`;

const AVAILABLE_LOT_QUANTITY_FOR_ITEM_QUERY = gql `
  query ($itemId: ID!, $packagingId: ID!, $storageId: ID!, $movementItemLotId: ID, $itemLotId: ID!) {
    accountContext {
      availableLotQuantity(itemId: $itemId, packagingId: $packagingId, storageId: $storageId, movementItemLotId: $movementItemLotId, itemLotId: $itemLotId)
    }
  }
`;

</script>

<style scoped></style>
